import React from 'react'

const Prestadores = () => {
   return (
      <>
         <div className="row mb-title" id="seccionPretadores">
            <div className="col s12 m12 l12 x12">
               <h5><b>PRESTADORES</b></h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Cartilla de Prestadores</h6>
            </div>
            <div className="col s6 m6 l3 x3 pull-x7">
               <a className="btn btn-large waves-effect waves-light bg-latitud pulse" rel="noopener noreferrer" href={`${process.env.REACT_APP_API_URL}/web/download/PrestadoresLatitudSur.pdf`}>Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
            <div  id="seccionContratos"/>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
      </>
   )
}

export default Prestadores